import React, { useState } from 'react';
import { Card, Input, Button, Typography, message } from 'antd';
import { IdcardOutlined } from '@ant-design/icons';
import { apiClient } from '../../config/apiClient';
import MainLayout from '../layout/layout';

const { Title, Text } = Typography;

const CompletarDocumento = ({ onCompletado }) => {
  const [documento, setDocumento] = useState('');
  const [loading, setLoading] = useState(false);

  const guardar = async () => {
    if (!documento.trim()) {
      message.warning('Ingrese su número de documento');
      return;
    }
    setLoading(true);
    try {
      const res = await apiClient.patch('/fichada/mi/documento', { documento: documento.trim() });
      if (res.ok) {
        message.success('Documento guardado correctamente');
        onCompletado?.();
      } else {
        const d = await res.json();
        message.error(d.message || 'Error al guardar');
      }
    } catch {
      message.error('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card style={{ maxWidth: 480, margin: '40px auto' }}>
      <Title level={3}>Completá tu perfil</Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
        Necesitamos tu número de documento para la fichada en el club.
      </Text>
      <Input
        size="large"
        prefix={<IdcardOutlined />}
        placeholder="Número de documento (DNI)"
        value={documento}
        onChange={(e) => setDocumento(e.target.value.replace(/\D/g, ''))}
        maxLength={11}
        style={{ marginBottom: 16 }}
      />
      <Button type="primary" size="large" block loading={loading} onClick={guardar}>
        Guardar y continuar
      </Button>
    </Card>
  );
};

const CompletarDocumentoPage = () => {
  const navigate = () => { window.location.href = '/#/home-alumno'; };

  return (
    <MainLayout>
      <CompletarDocumento onCompletado={navigate} />
    </MainLayout>
  );
};

export default CompletarDocumentoPage;
export { CompletarDocumento };
